var render = function () {
  var _class, _class2;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    class: (_class = {}, _class[_vm.$style.sidebarContainer] = true, _class[_vm.$style.isExpanded] = _vm.sidebarExpanded, _class)
  }, [_c('Transition', {
    attrs: {
      "name": "fade"
    }
  }, [_vm.sidebarExpanded ? _c('div', {
    class: _vm.$style.expandBackground
  }) : _vm._e()]), _c('div', {
    class: (_class2 = {}, _class2[_vm.$style.container] = true, _class2[_vm.$style.sidebarExpanded] = _vm.sidebarExpanded, _class2),
    attrs: {
      "data-sidebar": ""
    }
  }, [_c('div', {
    class: _vm.$style.logoContainer
  }, [_c('BaseLink', {
    attrs: {
      "href": "/",
      "target": "_self"
    }
  }, [_c('img', {
    class: _vm.$style.sidebarLogo,
    attrs: {
      "src": require("@assets/images/mottocenter-new-logo-blue.png"),
      "alt": "Logo"
    }
  }), _c('img', {
    class: _vm.$style.sidebarLogoMobile,
    attrs: {
      "src": require("@assets/images/mottocenter-new-logo-blue.png"),
      "alt": "Logo"
    }
  })]), _c('MottoIcon', {
    class: _vm.$style.mobileHamburgerClose,
    attrs: {
      "name": "HamburgerClose",
      "icon-color": "primary"
    },
    nativeOn: {
      "click": function click($event) {
        return _vm.$emit('collapse');
      }
    }
  })], 1), _vm._l(_vm.getSidebarRoutes, function (sidebarRoute) {
    return _c('SidebarItem', {
      key: sidebarRoute.title,
      attrs: {
        "route": sidebarRoute,
        "label": sidebarRoute.title,
        "icon": sidebarRoute.icon || sidebarRoute.title,
        "active": sidebarRoute.title === _vm.routeSidebarItemName,
        "selected-sub-sidebar-item": _vm.routeSubSidebarItemName,
        "sub-routes": _vm.getSubRoutes(sidebarRoute)
      }
    });
  })], 2)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }